import { Map } from 'immutable';
import { compose } from 'redux';
import { connect } from '../../../../common/react-redux';
import { ActionButtons as ActionButtonsPresenter } from './presenter';
import disableDraggingOverride from '../../../../common/components/shared/functionality/disableDraggingOverride';
import { ADD_CONTENT_POPOVER_KEY } from '@instructure/quiz-common';
import { featureOn } from '../../../../common/util/featureCheck';
function editingAddContentPopover(state) {
  return state.get('editing', Map()).some(function (isEditing, componentKey) {
    return componentKey.includes(ADD_CONTENT_POPOVER_KEY) && isEditing;
  });
}
function mapStateToProps(state) {
  return {
    editingAddContentPopover: editingAddContentPopover(state),
    questionCopyEnabled: featureOn('question_copy')
  };
}
export var ActionButtons = compose(connect(mapStateToProps), disableDraggingOverride)(ActionButtonsPresenter);
export default ActionButtons;